import styled from 'styled-components';

export const Header = styled.div`
  margin: 0 -2rem 1rem;
  padding: 0 2rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors[1000]};

  h3 {
    font-size: 1.125rem;
    margin-bottom: 0.3rem;
    font-weight: 700;
  }
`;

export const Body = styled.div`
  h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary};
  }

  i {
    font-size: 14px;
  }

  #red {
    color: ${({ theme }) => theme.colors[400]};
  }
`;

export const TextItalic = styled.p`
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
`;

export const TextPagraph = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #22272d;
`;
